<script lang="ts" setup>
import { computed } from 'vue'

import type { Props } from './types'

const props = defineProps<Props>()

const { t, n } = useI18n()

const totalPayment = computed(() => props.propertyPrice)
</script>

<script lang="ts">
export default {
  name: 'PriceOnlySimulator'
}
</script>

<template>
  <div class="price-only-simulator">
    <div class="price-only-simulator__title">
      <span
        v-sanitize="t('title')"
        class="display-7 lg:display-6" />
    </div>

    <p class="price-only-simulator__disclaimer">
      {{ t('disclaimer') }}
    </p>

    <div class="flex gap-12 mt-0">
      <ul class="flex flex-col justify-between w-full">
        <li class="price-only-simulator__list-item">
          <span class="price-only-simulator__list-item-total-payment body-1-m lg:hl-3-sb">
            {{ t('table.propertyPrice') }}
          </span>

          <div class="flex flex-row items-center gap-4">
            <span class="price-only-simulator__list-item-value">
              {{ n(totalPayment, 'currency') }}
            </span>

            <span class="body-3-m text-pine-600">
              {{ currency }}
            </span>
          </div>
        </li>
      </ul>
    </div>

    <slot />
  </div>
</template>

<style lang="scss">
.lh-roomie-v2 {
  .price-only-simulator {
    &__title {
      color: #004132;

      @apply mb-12;
    }

    &__disclaimer {
      @apply text-12 lg:text-14 text-carbon-600 mb-16;

      line-height: 140%;
    }

    &__list-item {
      @apply flex justify-between items-center text-carbon-600 text-14 lg:text-16;

      &-value {
        @apply font-medium text-right text-carbon-600 text-20 lg:text-22 ml-10;
      }
    }

    .price-only-simulator__list-item-total-payment {
      color: #004132;
    }

    .price-only-simulator__list-item-value {
      color: #004132;
      text-align: right;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: 120%;
      letter-spacing: -1.04px;

      @media (width >= 1024px) {
        @apply hl-2-sb;
      }
    }
  }
}
</style>

<i18n src="./i18n.json" lang="json" />
